import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// USER APIS
// ================================

// 🔹 LOGIN
export async function loginUser(user_email, user_password) {
  try {
    const fd = new FormData();
    fd.append("user_email", user_email);
    fd.append("user_password", user_password);

    const response = await axios.post(`${apiBaseUrl}userapis/login`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("loginUser error:", error);
    return { status: false, type: "danger", success: "Login failed" };
  }
}

// 🔹 SIGNUP
export async function signupUser(user_name, user_email, user_password, user_mobile,refBy,parent_id,business,category,location) {
  try {
    const fd = new FormData();
    fd.append("user_name", user_name);
    fd.append("user_email", user_email);
    fd.append("user_password", user_password);
    fd.append("user_mobile", user_mobile);
    fd.append("refBy", refBy);
    fd.append("parent_id", parent_id);
    fd.append("business", business);
    fd.append("category", category);
    fd.append("location", location);
    

    const response = await axios.post(`${apiBaseUrl}userapis/signup`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("signupUser error:", error);
    return { status: false, type: "danger", success: "Signup failed" };
  }
}

// 🔹 FORGOT PASSWORD
export async function forgotPassword(user_email) {
  try {
    const fd = new FormData();
    fd.append("user_email", user_email);

    const response = await axios.post(`${apiBaseUrl}userapis/forgot_password`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("forgotPassword error:", error);
    return { status: false, type: "danger", success: "Request failed" };
  }
}

// 🔹 CHANGE PASSWORD
export async function changePassword(user_id, old_password, new_password) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("old_password", old_password);
    fd.append("new_password", new_password);

    const response = await axios.post(`${apiBaseUrl}userapis/change_password`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("changePassword error:", error);
    return { status: false, type: "danger", success: "Password update failed" };
  }
}

// 🔹 UPDATE PROFILE
export async function updateProfile(user_id, user_name, user_mobile) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("user_name", user_name);
    fd.append("user_mobile", user_mobile);

    const response = await axios.post(`${apiBaseUrl}userapis/update_profile`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateProfile error:", error);
    return { status: false, type: "danger", success: "Profile update failed" };
  }
}

// 🔹 UPDATE BUSINESS PROFILE
export async function updateBusiness(buss_user, buss_title, buss_cat, buss_desc, buss_address) {
  try {
    const fd = new FormData();
    fd.append("buss_user", buss_user);
    fd.append("buss_title", buss_title);
    fd.append("buss_cat", buss_cat);
    fd.append("buss_desc", buss_desc);
    fd.append("buss_address", buss_address);

    const response = await axios.post(`${apiBaseUrl}userapis/update_business`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateBusiness error:", error);
    return { status: false, type: "danger", success: "Business update failed" };
  }
}

// 🔹 SAVE USER PLAN
export async function saveUserPlan(
  user_plan_user,
  user_plan_parent,
  user_plan_name,
  user_plan_price,
  user_plan_duration,
  user_plan_status
) {
  try {
    const fd = new FormData();
    fd.append("user_plan_user", user_plan_user);
    fd.append("user_plan_parent", user_plan_parent);
    fd.append("user_plan_name", user_plan_name);
    fd.append("user_plan_price", user_plan_price);
    fd.append("user_plan_duration", user_plan_duration);
    fd.append("user_plan_status", user_plan_status);

    const response = await axios.post(`${apiBaseUrl}userapis/save_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveUserPlan error:", error);
    return { status: false, type: "danger", success: "Plan save failed" };
  }
}

export async function getNotiList(
  noti_to,
  search_key,
  page
) {
  try {
    const fd = new FormData();
    fd.append("noti_to", noti_to);
    fd.append("search_key", search_key);
    fd.append("page", page);

    const response = await axios.post(`${apiBaseUrl}userapis/getNoties`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveUserPlan error:", error);
    return { status: false, type: "danger", success: "Plan save failed" };
  }
}

export async function getUdt(
  user_id
) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}userapis/get_udt`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveUserPlan error:", error);
    return { status: false, type: "danger", success: "Plan save failed" };
  }
}
export async function chkReview(user_id) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}gmb/get-reviews`,
      {
        params: { uid: user_id }, // cleaner than string
      }
    );

    return response.data;

  } catch (error) {
    console.error("chkReview error:", error);
    throw error; // important for upstream handling
  }
}